/**
 * @param {array} authorIds
 * @param {object} container
 */
function arsRelatedAuthors(authorIds, container, containerId) {

    /**
     * Control the element
     */
    function controller()
    {
		// Validate the author IDs
		if (!validateAuthorIds(authorIds)) {
			throw new Error("The author IDs could not be validated.")
		}

        // Show a loading animation
        loading()
        // return

        // Build the query string with the author IDs
		const queryString = createQueryString(authorIds)
		const url = encodeURI(
			`https://arsedition.eu/api/related/author/${queryString}`
		)
        // Fetch the author data from the Middleware API
		fetch(url)
			.then((response) => response.json())
			.then((json) => {
				if (json.code === 200) {
                    const sectionTitle = createSectionTitle()
                    const slides = createSlides(json.data)
                    const slider = createSlider(slides)
                    container.innerHTML = `${sectionTitle}${slider}`
                    initSlider()
				} else {
					// json.message
				}
			})
			.catch((err) => {
				console.error(err.message)
				console.error("Error while fetching related authors: ", err)
			})
			.finally(() => {
				// setLoading(false)
			})
    }

    /**
     * Check that each author ID consists only of digits
     *
     * @param {array} authorIds
     * @returns {boolean}
     */
    function validateAuthorIds(authorIds)
    {
	    return authorIds.every((id) => /^\d+$/.test(String(id)))
    }

    /**
     * Create a loading animation
     *
     * @returns {string}
     */
    function loading()
    {
        container.innerHTML = `<div class="__loading">
                <div class="__heading"></div>
                <div class="__row">
                    <div class="__col __col--1"></div>
                    <div class="__col __col--2"></div>
                    <div class="__col __col--3"></div>
                </div>
                <div class="__controls"></div>
            </div>`
    }

    /**
     * Create a query string from an array of author IDs
     *
     * @param {array} authorIds
     * @returns {string}
     */
    function createQueryString(authorIds)
    {
        return authorIds.join("-")
    }

    /**
     * Create and return the section title
     *
     * @returns {string}
     */
    function createSectionTitle()
    {
        return `<h2 class="ars-d-flex ars-align-items-center ars-mt-0 ars-lh-normal">
            <span class="ars-icon ars-mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                    <path class="ars-icon--secondary" d="M32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zm96-352a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm241.7 66.2C384.4 212.4 406.8 224 432 224c44.2 0 80-35.8 80-80s-35.8-80-80-80c-20.8 0-39.7 7.9-53.9 20.9C382 98.6 384 113.1 384 128c0 23.6-5.1 46-14.3 66.2zM434.8 352c27.9 35.3 44.7 79.7 45.2 128l128 0c-.7-70.8-58.3-128-129.3-128l-43.9 0z" />
                    <path class="ars-icon--primary" d="M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144l91.4 0zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zm431 208c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-4.4 0-8.8 .2-13.2 .5c11.3 9.4 21.6 19.9 30.7 31.5l43.9 0c71 0 128.6 57.2 129.3 128l-128 0c0 .8 0 1.5 0 2.3c0 10.8-2.8 20.9-7.6 29.7l136.9 0zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8c-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z"/>
                </svg>
            </span>
            Beteiligte&nbsp;<span class="ars-text-primary">Urheber:innen</span>
        </h2>`
    }

    /**
     * Create the slides
     *
     * @param {array} data
     * @returns {string}
     */
    function createSlides(data) {
        let output = ""
        data.forEach(slide => {
            const portrait = createPortrait(slide.image, slide.name, slide.handle)
            const description = createDescription(slide.description)
            const profileLink = createProfileLink(slide.handle)
            output += `<div class="swiper-slide ars-slider__slide">
                <div class="ars-card ars-card--shadow ars-card--related-author">
                    <div class="__portrait">
                        ${portrait}
                    </div>
                    <div class="__content">
                        <div class="ars-card__body">
                            <h3 class="ars-m-0 ars-fw-bold">
                                <a href="/collections/${slide.handle}" class="ars-text-primary ars-text-decoration-none">${slide.name}</a>
                            </h3>
                            ${description}
                            ${profileLink}
                        </div>
                    </div>
                </div>
            </div>`
        })
        return output
    }

    /**
     * Optionally create the portrait
     *
     * @param {array} data
     * @returns {string}
     */
    function createPortrait(image, name, handle)
    {
        const imageTag = (image.length === 0) ? "" : `<img src="${image}" alt="${name}" class="__portrait-img" loading="lazy" height="auto" width="auto">`
        return `<a href="/collections/${handle}" class="__portrait-link">
            ${imageTag}
        </a>`
    }

    /**
     * Optionally create the description
     *
     * @param {string} description
     * @returns {string}
     */
    function createDescription(description)
    {
        if (description.length === 0) {
            return ""
        }
        // Truncate description if too long
        if (description.length > 100) {
            description = description.substring(0, 100) + "..."
        }
        return `<div class="ars-mt-3 ars-fs-sm ars-lh-normal">
                ${description}
            </div>`
    }

    /**
     * Create the profile link
     *
     * @param {string} handle
     * @returns {string}
     */
    function createProfileLink(handle)
    {
        return `<a href="/collections/${handle}" class="button button--secondary ars-mt-4 ars-fw-bold">
                    <span class="ars-icon ars-mr-2">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                            <path class="ars-icon--secondary" d="M32 96l0 320c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64C46.3 64 32 78.3 32 96zM80 368c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80c0 8.8-7.2 16-16 16c-5.9 0-11.1-3.2-13.9-8l-164.3 0c-2.8 4.8-7.9 8-13.9 8c-8.8 0-16-7.2-16-16zM256 192a64 64 0 1 1 -128 0 64 64 0 1 1 128 0zm80-16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" />
                            <path class="ars-icon--primary" d="M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM112 368c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16s16-7.2 16-16zM352 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z" />
                        </svg>
                    </span>
                    Profil
                </a>`
    }

    /**
     * Create the slider
     *
     * @param {string} slides
     * @returns {string}
     */
    function createSlider(slides) {
        return `<div class="swiper ars-slider">
            <div class="swiper-wrapper">${slides}</div>
            <div class="ars-slider__controls" role="tablist">
                <button class="ars-btn--raw ars-slider__navigation ars-slider__navigation--prev" role="tab" aria-label="Zum vorherigen Slide">
                    <span class="ars-icon ars-icon--2x">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path class="ars-icon--secondary" d="M77.3 256c10.7-10.7 21.3-21.3 32-32L480 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0c-10.7-10.7-21.3-21.3-32-32z" />
                            <path class="ars-icon--primary" d="M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 182.6 361.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z" />
                        </svg>
                    </span>
                </button>
                <div class="ars-slider__pagination"></div>
                <button class="ars-btn--raw ars-slider__navigation ars-slider__navigation--next" role="tab" aria-label="Zum nächsten Slide">
                    <span class="ars-icon ars-icon--2x">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path class="ars-icon--secondary" d="M0 256c0 17.7 14.3 32 32 32l370.7 0c10.7-10.7 21.3-21.3 32-32c-10.7-10.7-21.3-21.3-32-32L32 224c-17.7 0-32 14.3-32 32z" />
                            <path class="ars-icon--primary" d="M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 256 329.4 150.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z" />
                        </svg>
                    </span>
                </button>
            </div>
        </div>`
    }

    /**
     * Initialize swiper
     */
    function initSlider()
    {
        window.arsSlider("#" + containerId + " .ars-slider", {
            slidesPerView: 1,
            spaceBetween: 32,
            breakpoints: {
                "750": {
                    slidesPerView: 2
                },
                "992": {
                    slidesPerView: 3
                },
                "1200": {
                    slidesPerView: 2
                }
            }
        })
    }

    /**
     * Initialize
     */
    controller()
}

/*
 * Insert the element into the target container
 */
const relatedAuthorsContainer = document.getElementById("related-authors")
if (relatedAuthorsContainer) {
    arsRelatedAuthors(arsData.relatedAuthors, relatedAuthorsContainer, "related-authors")
}